export default {
  default: {
    title: 'No Integration Platforms',
    paragraph: 'Please adjust your filters to see more results',
  },
}
